/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClassificationType } from '../../models/classification-type';
import { DemoAccountDataUpdateCto } from '../../models/demo-account-data-update-cto';
import { DemoDataPublishResultCto } from '../../models/demo-data-publish-result-cto';

export interface PublishDemoAccountDataAsync$Json$Params {
  demoDataType: ClassificationType;
      body?: DemoAccountDataUpdateCto
}

export function publishDemoAccountDataAsync$Json(http: HttpClient, rootUrl: string, params: PublishDemoAccountDataAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DemoDataPublishResultCto>> {
  const rb = new RequestBuilder(rootUrl, publishDemoAccountDataAsync$Json.PATH, 'put');
  if (params) {
    rb.path('demoDataType', params.demoDataType, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DemoDataPublishResultCto>;
    })
  );
}

publishDemoAccountDataAsync$Json.PATH = '/demo-account-data/{demoDataType}';
